export default __webpack_public_path__ + "static/media/pause-icon.205f979d.svg";